import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogin, useRegister } from '@coreAuth/useCase';
import { useStore } from '@store';
import { Modal, SigninTag, SignupTag } from '@components';
import type { IAuth, IRegister } from '@coreAuth/type';

interface IAuthModalProp {
  isOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
}

const AuthModal: FC<IAuthModalProp> = ({ isOpen, setIsModalOpen }) => {
  const width = window.innerWidth;
  const navigate = useNavigate();
  const { haveAccount, setHaveAccount } = useStore();
  const useLoginAuth = useLogin();
  const useRegisterAuth = useRegister();

  useEffect(() => {
    if (useLoginAuth.isSuccess || useRegisterAuth.isSuccess) {
      setIsModalOpen(false);
      navigate('');
    }
  }, [useLoginAuth.isSuccess, useRegisterAuth.isSuccess]);

  useEffect(() => {
    if (useLoginAuth.isError || useRegisterAuth.isError) handleCancel();
  }, [useLoginAuth.isError, useRegisterAuth.isError]);

  const handleSignin = (loginData: IAuth) => {
    useLoginAuth.mutate(loginData);
  };

  const handleSignup = (registerData: IRegister) => {
    useRegisterAuth.mutate(registerData);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      style={{ top: width < 600 ? 20 : 80 }}
      open={isOpen}
      closeIcon={false}
      footer={false}
      onCancel={handleCancel}>
      {haveAccount && (
        <SigninTag
          loading={useLoginAuth.isLoading}
          authCallback={handleSignin}
          onNoAccClick={() => setHaveAccount(false)}
        />
      )}
      {!haveAccount && (
        <SignupTag
          loading={useRegisterAuth.isLoading}
          authCallback={handleSignup}
          onHaveAcc={() => setHaveAccount(true)}
        />
      )}
    </Modal>
  );
};

export default AuthModal;
